<template>
    <div class="fun_pc">
        <!-- Logo -->
        <div class="fun_hero">
            <div class="fun_logo_wrap">
                <img class="fun_logo" src="../../../static/fun/logo.png" alt="HABBY FUN">
            </div>
        </div>

        <!-- Who We Are / HEART OVER HYPE -->
        <div class="fun_about">
            <div class="fun_about_row">
                <div class="fun_about_title" v-html="formatTitle(t.whoWeAre)"></div>
                <div class="fun_about_desc">{{ t.whoWeAreDesc }}</div>
            </div>
            <div class="fun_about_row fun_about_row_top">
                <div class="fun_about_title" v-html="formatTitle(t.heartOverHype)"></div>
                <div class="fun_about_desc">{{ t.heartOverHypeDesc }}</div>
            </div>
        </div>

        <!-- Our Fun Games -->
        <div class="fun_games">
            <div class="fun_games_inner">
                <div class="fun_games_title" v-html="formatTitle(t.ourFunGames)"></div>
                <div class="fun_games_list">
                    <img
                        class="fun_game_icon"
                        src="../../../static/fun/game_piroker.png"
                        alt="Piroker"
                    >
                    <div class="fun_game_placeholder">
                        <span class="fun_game_placeholder_text">{{ t.comingSoon }}</span>
                    </div>
                </div>
            </div>
        </div>

        <!-- Contact -->
        <div class="fun_contact">
            {{ t.contactLabel }}
            <a class="fun_contact_mail" :href="'mailto:' + t.contactEmail">{{ t.contactEmail }}</a>
        </div>
    </div>
</template>

<script>
import funLogic from './logic.js'

export default {
    name: 'FunPc',
    mixins: [funLogic],
    methods: {
        formatTitle(text) {
            return String(text || '').replace(/\n/g, '<br/>');
        },
    },
}
</script>

<style scoped lang="less">
@import "./pc.less";
</style>



// WEBPACK FOOTER //
// src/pages/fun/FunPc.vue